module.exports = __webpack_public_path__ + "static/media/cinema-screen.7e074343.png";